import { defineColumn } from '../../../components/tanstack-table/column';
import { TanStackTable } from '../../../components/tanstack-table/table';
import type { ProductOrder } from '../../../data/receiving';
import { emDashIfEmpty, productHeadColumns, productTailColumns } from './product-columns';

const productOrderIdentity = (p: ProductOrder): ProductOrder => p;

const UNKNOWN_COLUMNS = [
  ...productHeadColumns<ProductOrder>(productOrderIdentity),
  defineColumn<ProductOrder>({
    id: 'Item code',
    minWidth: 100,
    maxWidth: 160,
    accessorFn: (p) => emDashIfEmpty(p.item_code || p.raw_item_code),
    cell: ({ value }) => <span className="font-mono">{value}</span>,
  }),
  defineColumn<ProductOrder>({
    id: 'Barcode',
    minWidth: 120,
    maxWidth: 160,
    accessorFn: (p) => emDashIfEmpty(p.barcode),
    cell: ({ value }) => <span className="font-mono">{value}</span>,
  }),
  ...productTailColumns<ProductOrder>(productOrderIdentity),
];

export function UnknownProductsTable({ rows }: { rows: ProductOrder[] }) {
  return <TanStackTable data={rows} columns={UNKNOWN_COLUMNS} />;
}
